export function getTokenSubClaim(token?: string): string | undefined {
  if (!token) {
    return undefined;
  }

  const payload = token.split('.')[1];
  if (!payload) {
    return undefined;
  }

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='));
    const parsed = JSON.parse(decoded) as { sub?: string };
    return parsed.sub;
  } catch {
    return undefined;
  }
}
